import 'css-chunk:src/app/components/Charts/components/ROI/LineChart.module.scss';export default {
  "LineChart": "_LineChart_9h011_1",
  "text": "_text_9h011_6",
  "subtext": "_subtext_9h011_14"
};